export const CALLRAIL_SWAP_SCRIPT_SRC =
  'https://cdn.callrail.com/companies/786290431/6557eac645ff78314816/12/swap.js'
